import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from 'react';
import { Input } from '../Input';
import { Slider } from '../Slider';
import { SliderWithInputProps } from './sliderWithInput.types';
import { InputContainer, SliderWithInputContainer } from './sliderWithInput.styles';

export const SliderWithInput: FC<SliderWithInputProps> = (props) => {
  const { value, min } = props;
  const [sliderValue, setSliderValue] = useState<number>(value || min);
  const [inputValue, setInputValue] = useState<number>(value || min);

  useEffect(() => {
    setSliderValue(value);
    setInputValue(value);
  }, [value]);

  const handleInputOnChange = (event: FormEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value?.trim();
    setInputValue(Number(value));
    if (!value || isNaN(Number(value))) {
      return;
    }

    props.onChange && props.onChange(event);
    setSliderValue(Number(value));
  };

  const handleSliderOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value?.trim();
    setSliderValue(Number(value));
    if (!value || isNaN(Number(value))) {
      return;
    }
    props.onChange && props.onChange(event);
    setInputValue(Number(value));
  };

  return (
    <SliderWithInputContainer>
      <Slider {...props} value={sliderValue} onChange={handleSliderOnChange} />
      <InputContainer>
        <Input
          {...props}
          width={props.width || '44px'}
          value={inputValue}
          onChange={handleInputOnChange}
          textAlign="center"
        ></Input>
      </InputContainer>
    </SliderWithInputContainer>
  );
};
